export const DEFAULT_MENU = [
  { id: "home", label: "Home", type: "link", to: "/", visible: true, children: [] },
  { id: "search", label: "Search School/College", type: "search", to: "", visible: true, children: [] },
  { id: "digital", label: "Open Digital Edition", type: "link", to: "/digital-edition", visible: true, children: [] },
  {
    id: "list", label: "List Your School", type: "dropdown", to: "", visible: true, children: [
      { label: "Listing Options", to: "/list-your-school/listing-options", visible: true },
      { label: "Listing Questionnaire", to: "/list-your-school/listing-questionnaire", visible: true },
      { label: "Brochure and Media Kit", to: "/list-your-school/brochure-media-kit", visible: true },
    ],
  },
  { id: "about", label: "About", type: "link", to: "/about", visible: true, children: [] },
  { id: "contact", label: "Contact", type: "link", to: "/contact", visible: true, children: [] },
];
